"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});function e(o){switch(o.domain){case"code.org":return"code.org";case"aiday.org":return"aiday";default:return"code.org"}}exports.getBrandFromHostname=e;
//# sourceMappingURL=getBrandFromHostname.cjs.map
